import {
  type AppLocale,
  DEFAULT_LOCALE,
  LOCALES,
  localizePath,
  LOCALE_META,
} from "./locales";

export const SITE_URL = "https://findpoketcgstore.com";
export const SITE_NAME = "FindPoketCGStore";
export const SITE_LOGO_URL = `${SITE_URL}/findpoketcgstore.png`;

/** Build an absolute URL for a path that may already include a locale prefix. */
export function absoluteUrl(path: string): string {
  return new URL(path || "/", SITE_URL).toString();
}

/** Absolute URL for a bare site path under the given locale. */
export function absoluteLocalizedUrl(
  barePath: string,
  locale: AppLocale,
): string {
  return absoluteUrl(localizePath(barePath || "/", locale));
}

/** Schema.org / Open Graph language code for a locale. */
export function schemaInLanguage(locale: AppLocale): string {
  return LOCALE_META[locale].htmlLang;
}

export function alternateOgLocales(current: AppLocale): string[] {
  return LOCALES.filter((loc) => loc !== current).map(
    (loc) => LOCALE_META[loc].ogLocale,
  );
}

export { DEFAULT_LOCALE, LOCALES, localizePath, LOCALE_META };
